import React from 'react';
import { useObservable } from 'react-use-observable';

import { SummaryBar } from 'v2/components/Pages/Reports/SummaryBar';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { ExportPartnerComissions } from './Export';

export const Details = () => {
  const [totalItems] = useObservable(() => partnerCommissionsService.getTotalItems(), []);
  const [totalGain] = useObservable(() => partnerCommissionsService.getTotalGain(), []);
  const [isLoading] = useObservable(() => partnerCommissionsService.isLoading(), []);

  const commissionsCount = `${totalItems} ${totalItems > 1 ? 'parceiros' : 'parceiro'}`;

  if (isLoading) return null;

  return (
    <SummaryBar
      countLabel={commissionsCount}
      totalLabel='Total das Comissões'
      totalValue={totalGain || 0}
      exportSlot={
        <PermissionHide action='myeduzz:reports:exportar'>
          <ExportPartnerComissions />
        </PermissionHide>
      }
    />
  );
};
